export default function Disclaimer() {
  return (
    <div className="py-4">
      <div className="mb-6">
        <h3 className="font-bold mb-2 text-n-green">
          Não sabe o dia exato do seu transporte?
        </h3>
        <p className="text-sm text-n-text">
          Não se preocupe, você pode alterar a qualquer momento a data. Garanta
          as condições de seu transporte, com garantia de reembolso integral.
        </p>
      </div>
    </div>
  );
}
